// Import sound files
import zvukOkFile from "./sounds/ZvukOK.mp3";
import zvukChybaFile from "./sounds/ZvukCHYBA.mp3";
import zvukPozorFile from "./sounds/ZvukPOZOR.mp3";
import zvukNotificationFile from "./sounds/ZvukNOTIF.mp3";

const zvukOk = new Audio(zvukOkFile);
const zvukChyba = new Audio(zvukChybaFile);
const zvukPozor = new Audio(zvukPozorFile);
const zvukNotification = new Audio(zvukNotificationFile);

export const Zvuky = {
    playOk,
    playChyba,
    playPozor,
    playNotification
};

async function playOk() {
    await playSound(zvukOk);
}

async function playChyba() {
    await playSound(zvukChyba);
}

async function playPozor() {
    await playSound(zvukPozor);
}

async function playNotification() {
    await playSound(zvukNotification);
}

async function playSound(zvuk) {
    if (!zvuk.paused && zvuk.currentTime > 0 && !zvuk.ended) {
        zvuk.pause();
        zvuk.currentTime = 0;
    }
    await zvuk.play();
}



// WEBPACK FOOTER //
// ./src/components/common/Zvuky.js